export const AMMONIA = "Ammonia";
export const PAPER_ROLL = "Paper Roll";
export const HAND_TOWEL = "Hand Towel";
export const SOAP = "Soap";

// password
// address
// export
export const CLOUD_SERVER = "http://210.24.187.227:5065";
export const SERVICE = "smart_toilet";
export const WEB_SERVER = "http://210.24.187.227:8005";
// export const WEB_SERVER = "http://127.0.0.1:8005";

export const PERMISSION = {
    SUPER: 0,
    ADMIN: 1,
    MANAGER: 2,
    VIEWER: 3,
    WEB_SERVER: 5,
    LOG_OUT: 99,
};

export const ES = {
    ADD_EVENT: "add",
    UPDATE_EVENT: "update",
    UPDATE_SENSOR: "update-sensor",
    DELETE_EVENT: "delete",
    FEEDBACK: "FBPL",
    UPDATE_DEVICE: "update-device",
    CHECK_IN: "check-in",
    ERROR: "error",
};

export const FEEDBACK = {
    SOAP: "No Hand Soap",
    PAPER: "No Paper Roll",
    FLOOR: "Wet Floor",
    SMELL: "Ammonia level High",
};
